import React from 'react';

const AboutMe = () => (
    <div>
        <h2>About Me</h2>
        <p>
            I am Dr. Amulya Kutikuppala, a radiology resident at <b> KMC, Manipal University, Karnataka</b>, specializing in CT, MRI, ultrasound, and non-vascular interventional procedures. I am dedicated to enhancing my skills in patient care and making meaningful contributions to the field of radiology.
        </p>
        <h3>Strengths</h3>
        <ul>
            <li>Advanced diagnostic imaging in CT, MRI, and ultrasound.</li>
            <li>Proficient in ultrasound-guided procedures including biopsies and FNAC.</li>
            <li>Experience in interventional radiology and emergency radiology.</li>
            <li>Research-focused with multiple published papers in radiology and medical science.</li>
            <li>Proficient in using PACS, DICOM viewers and other medical software tools.</li>
        </ul>
        <h3>Goals</h3>
        <ul>
            <li>To advance my expertise in radiology, particularly in emergency cases and interventional procedures.</li>
            <li>To contribute significantly to ongoing research and publications in the field of radiology.</li>
            <li>To mentor young professionals and contribute to academic discussions in radiology.</li>
        </ul>
        <div className="image-box">
            <img
                src="/Kasturba-Medical-College-Manipal-.jpeg"
                alt="KMC Manipal Campus"
                className="img-fluid mt-4"
            />
        </div>
    </div>
);

export default AboutMe;
